export default __webpack_public_path__ + "static/media/whiteboard.81d833d8.jpeg";